'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Map as ImmutableMap } from 'immutable';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedDuration from 'I18n/components/FormattedDuration';
import { getDateString } from '../../../utils/timeUtils';
import { getUserTextKey } from '../../../utils/userUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SpanWithPointer = styled.span.withConfig({
  displayName: "DateCell__SpanWithPointer",
  componentId: "sc-1asie2c-0"
})(["cursor:pointer;"]);
export const DATE_CELL_USE = {
  DEFAULT: 'DEFAULT',
  RELATIVE: 'RELATIVE'
};
const DateCell = ({
  timestamp,
  user,
  tooltipText,
  use = DATE_CELL_USE.DEFAULT
}) => {
  const userTextKey = getUserTextKey(user);
  if (timestamp) {
    const fullFormattedDate = /*#__PURE__*/_jsx(FormattedDateTime, {
      value: timestamp,
      format: "lll z",
      type: "userTz"
    });
    return /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: fullFormattedDate,
        disabled: use === DATE_CELL_USE.DEFAULT,
        children: /*#__PURE__*/_jsx("span", {
          children: use === DATE_CELL_USE.RELATIVE ? /*#__PURE__*/_jsx(FormattedDuration, {
            to: timestamp,
            includeAffix: true
          }) : getDateString(timestamp)
        })
      }), /*#__PURE__*/_jsx("br", {}), user ? /*#__PURE__*/_jsx("small", {
        children: userTextKey === 'fullName' ? user.get('fullName') : /*#__PURE__*/_jsx(FormattedMessage, {
          message: userTextKey
        })
      }) : null]
    });
  } else {
    return /*#__PURE__*/_jsx("td", {
      children: tooltipText ? /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: tooltipText
        }),
        children: /*#__PURE__*/_jsx(SpanWithPointer, {
          children: "--"
        })
      }) : '--'
    });
  }
};
DateCell.propTypes = {
  timestamp: PropTypes.number,
  user: PropTypes.instanceOf(ImmutableMap),
  tooltipText: PropTypes.string
};
export default DateCell;